import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { CheckboxProps } from "semantic-ui-react/dist/commonjs/modules/Checkbox/Checkbox";
import { Button, Checkbox, Form } from "semantic-ui-react";
import { useHistory } from "react-router";
import { EntrataProperty, SaveEntrataUserL1 } from "../../../services/IntegrationApi";
import { NetworkSearch } from "../NetworkSearch";
import useAuth from "../../login/AuthContext";
import { TimedAlert } from "../../../components/TimedAlert";
import { ENTRATA_URL } from "./EntrataUsers";

interface EntrataUserL1MappingModalProps {
  show: boolean;
  closeModal: () => void;
  property: EntrataProperty;
  entrataUserId: number;
}

export const EntrataUserL1MappingModal: React.FunctionComponent<EntrataUserL1MappingModalProps> = ({
  show,
  closeModal,
  property,
  entrataUserId,
}) => {
  const [inputs, setInputs] = useState<{
    importApplicants: boolean;
    importSignedApplicants: boolean;
    enabled: boolean;
    l1Id: number;
    error: boolean;
    importFullRooms: boolean;
    importMonthToMonth: boolean;
    notifyFullRooms: boolean;
  }>({
    importApplicants: false,
    importSignedApplicants: false,
    enabled: false,
    l1Id: 0,
    error: false,
    importFullRooms: true,
    importMonthToMonth: false,
    notifyFullRooms: true
  });

  const { getAuthToken } = useAuth();
  const history = useHistory();

  return (
    <Modal show={show} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Entrata User to L1</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <TimedAlert
          visible={inputs.error}
          variant="danger"
          setVisible={() => {
            setInputs({ ...inputs, error: true });
          }}
        >
          Unable to save
        </TimedAlert>
        <Form>
          <Form.Field>
            <label>Property Name</label>
            <input type="text" value={property.propertyName} disabled />
          </Form.Field>
          <Form.Field>
            <label>Network</label>
            <NetworkSearch
              setNetwork={(id) => {
                setInputs({ ...inputs, l1Id: id });
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Import applicants</label>
            <Checkbox
              toggle
              checked={inputs.importApplicants}
              onChange={(event: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {
                setInputs({ ...inputs, importApplicants: !!data.checked });
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Import Signed applicants</label>
            <Checkbox
              toggle
              checked={inputs.importSignedApplicants}
              onChange={(event: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {
                setInputs({ ...inputs, importSignedApplicants: !!data.checked });
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Enabled</label>
            <Checkbox
              toggle
              checked={inputs.enabled}
              onChange={(event: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {
                setInputs({ ...inputs, enabled: !!data.checked });
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Import full rooms</label>
            <Checkbox
              toggle
              checked={inputs.importFullRooms}
              onChange={(event: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {
                setInputs({ ...inputs, importFullRooms: !!data.checked });
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Notify full rooms</label>
            <Checkbox
              toggle
              checked={inputs.notifyFullRooms}
              onChange={(event: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {
                setInputs({ ...inputs, notifyFullRooms: !!data.checked });
              }}
            />
          </Form.Field>
        </Form>
        <Button
          type="submit"
          onClick={async () => {
            const request = {
              enabled: inputs.enabled,
              importApplicants: inputs.importApplicants,
              importSignedApplicants: inputs.importSignedApplicants,
              l1Id: inputs.l1Id,
              propertyName: property.propertyName,
              importFullRooms: inputs.importFullRooms,
              importMonthToMonth: inputs.importMonthToMonth,
              notifyFullRooms: inputs.notifyFullRooms
            };

            SaveEntrataUserL1(entrataUserId, property.propertyId, request, await getAuthToken()).then(
              () => {
                closeModal();
                history.push(ENTRATA_URL);
              },
              () => {
                setInputs({ ...inputs, error: true });
              }
            );
          }}
        >
          Submit
        </Button>
      </Modal.Body>
    </Modal>
  );
};
